/**
 * 
 * @returns 
 */
export const hellopanda_func = {

  resizeHeightAllow: 200, // 모바일 화면 높이가 변하는 양을 체크

  /**
   * 개발환경 체크
   */
  isDevelopment() {

    return window.location.hostname === 'localhost';

  },

  /**
   * 패널 오픈 상태
   */
  initialOpen(condition = [], className = 'components-panel__body__required') {

    if (!Array.isArray(condition)) {
      condition = [];
    }

    return condition.some(value => value) ? className : '';

  },

  /**
   * 아이프레임을 찾는다
   */
  getDocument() {
    const iframe = document.querySelector('iframe[name="editor-canvas"]');
    const innerDoc = iframe?.contentDocument;
    return innerDoc ? innerDoc : document ;
  },

  /**
   * 허용값 불리언 반환
   */
  isValue(value, ignore) {
    // ignore 값이 주어졌고 value가 그와 같다면 true 반환
    if (ignore !== undefined && value === ignore) {
      return true;
    }
  
    // value가 0이거나 null 또는 undefined면 false 반환
    if (value === 0 || value === undefined || value === null) {
      return false;
    }
  
    // 그 외의 값들은 true 반환
    return true;
  },

  /**
   * 숫자인지 판별
   * @param {*} str 
   * @returns 
   */
  isNumber(str) {
    return !isNaN(str) && str.trim() !== '';
  },

  /**
   * 문자열을 숫자로 반환
   * @param {*} string 
   * @returns 
   */
  getNumber(input) {
    let matches = String(input).match(/(\d+)/);
    return matches ? parseInt(matches[0], 10) : 0;
  },

  /**
   * 문자열에 숫자가 하나라도 포함되어 있으면 true 반환
   * @param {string} input 
   * @returns {boolean}
   */
  containsNumber(input) {
    return /\d/.test(input);
  },

  /**
   * 오브젝트가 있는지 체크 (비어있으면 true 반환)
   * @param {*} obj 
   * @returns 
   */
  isObjectEmpty (obj) {
    if (typeof obj === 'object') {
      return Object.keys(obj).length === 0;
    } else {
      return obj.length === 0;
    }
  },

  /**
   * 유니크한 클래스만 리턴
   * @param {*} existingClass 
   * @param {*} newClasses 
   * @returns 
   */
  mergeClass (existingClass, newClasses) {
    const classArray = [...existingClass.split(' '), ...newClasses];
    const uniqueClassArray = [...new Set(classArray)];
    return uniqueClassArray.join(' ');
  },

  /**
   * 중복 클래스를 삭제하고 유일한 클래스만 배열로 추출
   * @param {*} attributes 
   * @param {*} mergeclass 
   * @returns 
   */
  mergeAttributeClass (attributes, mergeclass) {
    let newClassArray = attributes.className?.split(' ') || [];
    newClassArray = newClassArray.filter(item => {
      const found = mergeclass.find(option => option.value === item);
      return !found;
    });
    return newClassArray;
  },

  /**
   * 
   * @param {*} currentClassName 
   * @param {*} action 
   * @param {*} classToToggle 
   * @returns 
   */
  updateClassName(currentClassName = '', classToToggle = [], action) {
    const classList = currentClassName.trim().split(/\s+/).filter(Boolean);
    const classSet = new Set(classList);

    if (action === 'insert') {
      classToToggle.forEach((cls) => classSet.add(cls));
    } else if (action === 'remove') {
      classToToggle.forEach((cls) => classSet.delete(cls));
    }

    return Array.from(classSet).join(' ');
  },

  /**
   * core 에서 스타일로 적용할지 판단하는 배열 정의
   * @param {*} attributes 
   * @param {*} arr 
   * @returns 
   */
  getApplyAttribute (attributes, arr) {
    let hellopanda = Array.isArray(attributes.style?.hellopanda) ? attributes.style?.hellopanda : [];
    arr.forEach(item => {
      const key = Object.keys(item)[0]; // 객체의 첫 번째 키를 가져옴
      const value = item[key]; // 해당 키에 대응하는 값을 가져옴
      hellopanda = hellopanda?.filter(item => item != key);
      if (value && !this.isObjectEmpty(value)) {
        hellopanda.push(key);
      }
    });
    return hellopanda;
  },

  /**
   * 초기화 상태로 스타일을 리셋
   * @param {*} attributes 
   * @param {*} arr 
   * @param {*} newStyle 
   */
  removeApplyAttribute (attributes, arr, newStyle, store) {
    arr.forEach(item => {
      const key = Object.keys(item)[0]; // 객체의 첫 번째 키를 가져옴
      const value = item[key]; // 해당 키에 대응하는 값을 가져옴
      if (typeof newStyle.hellopanda === 'object' && !value) {
        newStyle.hellopanda = newStyle.hellopanda.filter(item => item !== key);
      }
      if (typeof store === 'object' && !value) {
        delete store[key];
      }
    });
    if (!newStyle?.hellopanda?.length) delete newStyle.hellopanda;
  },

  /**
   * 빈 오브젝트를 제거
   * @param {*} obj 
   * @returns 
   */
  removeEmptyObject (obj) {
    const newObj = Array.isArray(obj) ? [] : {};
    for (const key in obj) {
      // Skip inherited properties
      if (!obj.hasOwnProperty(key)) continue;
      const value = obj[key];
      if (typeof value === 'object' && value !== null) {
        // Recursively call removeEmpty
        const cleanedValue = this.removeEmptyObject(value);
        if (Object.keys(cleanedValue).length > 0) {
          newObj[key] = cleanedValue;
        }
      } else if (value !== '' && value !== undefined && value !== null) {
        newObj[key] = value;
      }
    }
    return newObj;
  },

  /**
   * 순서 재 배합
   * @param {*} units 
   * @param {*} hint 
   * @returns 
   */
  prioritizeUnit (units, hint) {
    // hint에 매칭되는 항목을 첫 번째로 이동시키기
    let index = units.findIndex(unit => unit.value === hint);
    if (index !== -1) {
      let item = units.splice(index, 1)[0];
      units.unshift(item);
    }
  
    // default 값을 순서대로 재정의하기
    units.forEach((unit, idx) => {
      unit.default = idx + 1;
    });
  
    return units;
  },

  /**
   * EM 단위를 기본으로 하는 Unit
   * @returns 
   */
  getNewUnitArray (key = 'em') {

    let units = [
      { value: 'em', label: 'em', default: 1, step: .1 },
      { value: 'rem', label: 'rem', default: 2, step: .1 },
      { value: 'px', label: 'px', default: 3, step: 1 },
      { value: '%', label: '%', default: 4, step: .1 },
      { value: 'vw', label: 'vw', default: 5, step: .1 },
      { value: 'vh', label: 'vh', default: 6, step: .1 },
    ];
    units = this.prioritizeUnit(units, key);

    return units;
  },

  /**
   * GSAP 전용 단위
   * @returns 
   */
  getGsapUnitArray (key = 'em') {

    let units = [
      { value: '', label: 'px', default: 3, step: 1 },
      { value: '%', label: '%', default: 4, step: .1 },
    ];
    units = this.prioritizeUnit(units, key);

    return units;
  },

  /**
   * 단위 수치를 clamp 형식으로 변환한다.
   * 5rem이 들어가면 대략 9vw 를 반환한다.
   * var(--wp--preset--spacing--70) = min(5.00rem, 9vw); ( block.json 설정에 근거하여 )
   * @param {*} input 
   * @returns 
   */
  calculateResponsive(input) {
    if (typeof input !== 'string') {
      return input;
    }
  
    const unitPattern = /(\d+(?:\.\d+)?)(em|rem|px|%|vw|vh)/;
    const match = input.match(unitPattern);
  
    if (!match) {
      return input;
    }
  
    const value = parseFloat(match[1]);
    const unit = match[2];
  
    // Only process em and rem units
    if (unit !== 'em' && unit !== 'rem') {
      return input;
    }
  
    // Fixed conversion: 5rem ≈ 9vw
    const vwEquivalentValue = (value / 5) * 10;
  
    return `min(${value}${unit}, ${vwEquivalentValue.toFixed(2)}vw)`;
  },

  /**
   * BoxControl 컴포넌트의 단위를 기본적으로 설정해준다.
   * @returns 
   */
  getDefaultUnitArray(obj) {
    if (obj !== null && typeof obj === 'object' && !Array.isArray(obj)) {
      const newObj = Object.assign({}, obj); // 객체의 얕은 복사 수행
      Object.keys(newObj).forEach(key => {
        let value = newObj[key];
        // if (typeof parseInt(value) === 'number' && !isNaN(parseFloat(value))) {
        //   value += this.getNewUnitArray()[0]?.value || 'px';
        // }
        newObj[key] = this.calculateResponsive(value);
      });
      return newObj;
    } else {
      return obj;
    }
  },

  /**
   * HEX에 투명도를 적용한다.
   * @param {*} hex 
   * @param {*} opacity 
   * @returns 
   */
  getHexToRGBA (hex, opacity) {
    // 입력된 투명도 값 (0~1)을 16진수로 변환
    const alphaHex = Math.round(opacity * 255).toString(16);
    // 변환된 16진수 값을 두 자리로 만듭니다.
    const paddedAlphaHex = ('0' + alphaHex).slice(-2);
    // 기존의 Hex 코드에 투명도 값을 추가하여 반환
    return hex + paddedAlphaHex;
  },

  /**
   * 두개의 오브젝트가 서로 같은지 체크
   * @param {*} a 
   * @param {*} b 
   * @returns 
   */
  isSameObject (a = {}, b = {}, ignoreKeys = []) {

    // 비교할 속성만 남긴 객체를 생성
    const filteredA = Object.keys(a)
      .filter(key => !ignoreKeys.includes(key))
      .reduce((obj, key) => ({ ...obj, [key]: a[key] }), {});
      
    const filteredB = Object.keys(b)
      .filter(key => !ignoreKeys.includes(key))
      .reduce((obj, key) => ({ ...obj, [key]: b[key] }), {});
      
    // 두 객체의 속성 개수가 다를 경우 바로 false 반환
    if (Object.keys(filteredA).length !== Object.keys(filteredB).length) {
      return false;
    }

    // 각 속성을 하나씩 확인하면서 값이 일치하는지 확인
    for (let key in filteredA) {
      if (filteredA[key] !== filteredB[key]) {
        return false;
      }
    }

    // 모든 속성이 동일하다면 true 반환
    return true;
  },

  /**
   * 스타일을 한줄로 리턴한다.
   * @param {*} content 
   * @returns 
   */
  trimStyle (content) {
    return content.trim().replace(/\s+/g, ' ');
  },

  /**
   * 리액트 오브젝트 스타일을 해석, 반환한다.
   * @param {*} style 
   * @returns 
   */
  objectToStyle (style) {
    const style_rule = wp.styleEngine.getCSSRules(style || {});
    const result = style_rule.reduce((acc, cur) => {
      acc[cur.key] = cur.value;
      return acc;
    }, {});

    return result;
  },

  /**
   * 구글 메테리얼 아이콘의 코드를 추출한다.
   * <span class="material-symbols-outlined">fullscreen</span> -> fullscreen
   * @param {*} str 
   * @returns 
   */
  getMaterialCode (str) {
    return str?.replace(/<[^>]*>/g, '')?.trim();
  },

  /**
   * 정규식을 사용하여 클래스명이 정확히 존재하는지 확인
   */
  hasClass (className, targetClass) {
    const regex = new RegExp(`(^|\\s)${targetClass}(\\s|$)`);
    return regex.test(className);
  },

  /**
   * 랜덤 숫자 추출
   * @param {*} max 
   */
  randomNumber (max) {
    if (typeof max !== 'number' || isNaN(max)) {
      return 0;
    }
    return Math.floor(Math.random() * max) + 1;
  },

  /**
   * 난수 생성
   * @param {*} length 
   * @returns 
   */
  randomString (length) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  },

  /**
   * 난수 생성 ( 문자만 )
   * @param {*} length 
   * @returns 
   */
  randomOnlyString (length) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  },

  /**
   * CSS Minify 리턴
   * @param {*} css 
   * @returns 
   */
  minifyCSS (css) {
    return css
      .replace(/\s*({|}|;|:|,)\s*/g, '$1')  // Remove spaces around {} ; : ,
      .replace(/;\s*}/g, '}')              // Remove space before closing }
      .replace(/\s{2,}/g, ' ')             // Replace multiple spaces with single space
      .replace(/\/\*[\s\S]*?\*\//g, '');   // Remove comments
  },

  /**
   * 모바일 기기 환경 체크
   */
  isDeviceMobile () {

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    // iOS, Android, Windows Phone 체크
    if (/android/i.test(userAgent)) {
        return true; // Android 기기
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true; // iOS 기기
    }

    if (/windows phone/i.test(userAgent)) {
        return true; // Windows Phone 기기
    }

    return false; // 모바일 환경이 아님 (데스크탑)

  },

  /**
   * 어트리뷰트 스타일 플랫화
   * css 명칭에 맞는것만 변환이 가능하다.
   * @param {*} obj 
   * @returns 
   */
  styleToFlat(obj) {
    if (typeof obj != 'object') {
      return {};
    }

    const flattened = {};
    function recursiveFlatten(obj, prefix = '') {
      for (const key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          // 객체인 경우 재귀적으로 접근, key를 결합해서 사용
          recursiveFlatten(obj[key], prefix + key + '-');
        } else {
          // 기본 값인 경우 flat 형태로 저장
          flattened[prefix + key] = obj[key];
        }
      }
    }

    recursiveFlatten(obj);
    return flattened;
  },

  /**
   * variable 색상 가져오기
   * @param {*} str 
   */
  getColor (str) {
    const colors = [
      'white', 'black', 'base', 'contrast', 'primary', 'secondary', 
      'step-1', 'step-2', 'step-3', 'step-4', 'step-5', 'step-6', 'step-7', 'step-8', 'step-9', 'step-10', 
      'step-11', 'step-12', 'step-13', 'step-14', 'step-15', 'step-16', 'step-17', 'step-18', 'step-19', 'step-20', 
    ];
    const strOrigin = str?.replace('var:preset|color|', '') || '';
    if (colors.includes(strOrigin)) {
      return `var(--wp--preset--color--${strOrigin})`;
    } else {
      return str;
    }
  },

  /**
   * 색상 변수 가져오기
   */
  get_color_variables (colors, iconColor) {
    let variable = '';
    const item = colors.find(item => item.color === iconColor);
    if (item) {
      variable = `var(--wp--preset--color--${item.slug})`;
    }
    return variable ? variable : iconColor;
  },

  /**
   * 변수 색상 가져오기
   */
  get_variables_color (colors, variables) {
    const regex = /var\(--wp--preset--color--([a-zA-Z0-9-]+)\)/;
    const matched = variables ? variables.match(regex) : null ;
    if (matched) {
      const item = colors.find(item => item.slug === matched[1]);
      if (item) {
        return item.color;
      }
    }
    return variables;
  },

  /**
   * 변수 색상 슬러그 가져오기
   */
  get_variables_slug (variables, key) {
    const regex = /var\(--wp--preset--color--([a-zA-Z0-9-]+)\)/;
    const matched = variables ? variables.match(regex) : null ;
    if (matched) {
      return key +'-'+ matched[1];
    }
    return '';
  },

  /**
   * variable 폰트 크기 가져오기
   * @param {*} str 
   */
  getFontSize (str) {
    const colors = [
      'xx-small', 'x-small', 'small', 'medium', 'large', 
      'x-large', 'xx-large', 'xxx-large', 'xxxx-large', 
      'm-huge', 'x-huge', 'xx-huge', 'xxx-huge', 'xxxx-huge', 
    ];
    if (colors.includes(str)) {
      return `var(--wp--preset--font-size--${str})`;
    } else {
      return str;
    }
  },

  /**
   * wp.styleEngine.getCSSRules
   * 여기서 추출한 배열을 style={ 여기 } 용도로 추출
   * @param {*} arr 
   * @returns 
   */
  styleEngineToCss(arr) {
    const styleObject = {};
  
    arr.forEach(({ key, value }) => {
      if (key && value) {
        // key를 camelCase로 변환하여 React의 style 객체에 맞추기
        const camelCaseKey = key.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
        styleObject[camelCaseKey] = value;
      }
    });
  
    return styleObject;
  },

  /**
   * 직접적인 스타일만 적용
   * @param {Object} obj 
   * @returns {Object} 필터링된 스타일 객체
   */
  styleOnlyValue(obj) {
    // obj의 각 속성을 검사하여 object, undefined, null 값은 제외합니다.
    const filteredObj = Object.fromEntries(
        Object.entries(obj).filter(
            ([key, value]) => value !== null && value !== undefined && typeof value !== 'object'
        )
    );
    return filteredObj;
  },

  /**
   * 상위 블록 가져오기
   */
  getClosestBlock (clientId, blockName) {
    const { getBlockRootClientId, getBlock } = wp.data.select('core/block-editor');
    
    let currentClientId = clientId;

    // 반복적으로 부모 블록을 찾음
    while (currentClientId) {
      const parentClientId = getBlockRootClientId(currentClientId);

      // 부모가 없으면 중지
      if (!parentClientId) {
        return null;
      }

      const parentBlock = getBlock(parentClientId);

      // 부모 블록이 swiper-block인지 확인
      if (parentBlock && parentBlock.name === blockName) {
        return parentBlock;
      }

      // 부모가 swiper-block이 아니면 계속 위로 탐색
      currentClientId = parentClientId;
    }

    return null;
  },

  /**
   * 특정 오브젝트만 추출 (keys에 해당하는 속성만 추출)
   */
  getForObject (obj, keys) {
    const result = {};
    keys.forEach(key => {
        if (obj.hasOwnProperty(key)) {
            result[key] = obj[key];
        }
    });
    return result;
  },

  /**
   * 특정 오브젝트만 빼고 추출 (keys에 해당하는 속성 제외한 나머지 속성 추출)
   */
  getOnlyObject (obj, keys) {
    const result = {};
    Object.keys(obj).forEach(key => {
        if (!keys.includes(key)) {
            result[key] = obj[key];
        }
    });
    return result;
  },

  /**
   * 듀오톤으로 치환하기
   */
  convertDuotonePreset(value) {
    if (value.startsWith('var:preset|duotone|')) {
      const presetName = value.replace('var:preset|duotone|', '');
      return `var(--wp--preset--duotone--${presetName})`;
    }
    return value; // 기본적으로 변환이 필요 없는 경우 그대로 반환
  },

  /**
   * 현재 블록이 DOM 상 어떤 template-part에 포함돼 있는지 slug 기준으로 반환
   */
  getClosestPartSlugFromDOM(clientId) {
    const blockEl = this.getDocument().querySelector(`[data-block="${clientId}"]`);
    if (!blockEl) return null;

    // 가장 가까운 부모 중 wp-block-template-part 찾기
    const closestPart = blockEl.closest('.wp-block-template-part');
    if (!closestPart) return null;

    return closestPart.getAttribute('slug') || null;
  },
  isSameSlugPartDuplicated_DOM(clientId) {
    // 패턴 선택 페이지라면 업데이트를 중지한다.
    const patterns = this.getDocument().querySelector('.edit-site-page-patterns-dataviews');
    if (patterns) return true;

    // 중복 슬러그가 아니라면 업데이트를 요청한다.
    const slug = this.getClosestPartSlugFromDOM(clientId);
    if (!slug) return false;

    const matchingParts = this.getDocument().querySelectorAll(`.wp-block-template-part[slug="${slug}"]`);
    return matchingParts.length > 1;
  },

  gerParameter(param) {
    try {
      const urlObj = new URL(window.location.href)

      // query string에서 tab 확인
      const queryTab = urlObj.searchParams.get(param)
      if (queryTab !== null) return queryTab

      // query string에 없다면 hash에서 tab 확인
      if (urlObj.hash) {
        const hashString = urlObj.hash.substring(1) // '#' 제거
        const hashParams = new URLSearchParams(hashString)
        const hashTab = hashParams.get(param)
        if (hashTab !== null) return hashTab
      }

      return undefined
    } catch (err) {
      return undefined
    }
  }
}